export const CSV = async (data: any[], filename: string) => {
    console.log("Masuk");
    console.log(data)
    if (!data.length) return;
  
    console.log(data);
    const headers = Object.keys(data[0]).join(",") + "\n";
    const rows = data.map(row =>
      Object.values(row).map(val => `"${val}"`).join(",")
    ).join("\n");
  
    const csvContent = "data:text/csv;charset=utf-8," + headers + rows;
    const encodedUri = encodeURI(csvContent);
  
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", filename + ".csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    return "export-csv-success";
}
  